import axios from 'axios';

const API_BASE_URL = 'https://app-brain-gym.samrruddhi.in/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Include credentials for member routes
    if (config.url && config.url.includes('/member/')) {
      config.withCredentials = true;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';
      const currentPath = window.location.pathname;
      
      // For member routes, try to refresh token from cookie before giving up
      if (requestUrl.includes('/member/') || currentPath.startsWith('/member/')) {
        try {
          // Try to get fresh token from cookie
          const cookieResponse = await fetch('https://app-brain-gym.samrruddhi.in/api/member/check-auth', {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Accept': 'application/json',
            },
          });

          if (cookieResponse.ok) {
            const data = await cookieResponse.json();
            if (data.authenticated && data.token) {
              // Update localStorage with fresh token
              localStorage.setItem('token', data.token);
              localStorage.setItem('user', JSON.stringify(data.member));
              localStorage.setItem('userType', 'member');
              
              // Retry the original request with new token
              error.config.headers.Authorization = `Bearer ${data.token}`;
              return axios.request(error.config);
            }
          }
        } catch (cookieError) {
          console.error('Cookie refresh failed:', cookieError);
        }
        
        // If cookie refresh failed, clear data and redirect to member login
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('userType');
        
        if (currentPath !== '/member/login') {
          window.location.href = '/member/login';
        }
      } else if (requestUrl.includes('/admin/') || currentPath.startsWith('/admin/')) {
        // For admin routes, clear data and redirect (no persistent cookies for admin)
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('userType');
        
        if (currentPath !== '/admin/login') {
          window.location.href = '/admin/login';
        }
      }
    }
    return Promise.reject(error);
  }
);
export default api;